__turbopack_context__.v({
  "badge": "CartNavLink-module__Apub_W__badge",
  "root": "CartNavLink-module__Apub_W__root",
});
